import * as React from "react";

export interface ISearchTextTextboxProps {
  itemID?: string;
  labelText: string;
  searchText: string;
  tabIndex?: number;
  onChange: (event: any) => any;
  onFocussed?: (itemID: string) => void;
}

export const SearchTextTextbox = (props: ISearchTextTextboxProps) => {

  const onFocussed = () => {
    if (props.onFocussed) { props.onFocussed(props.itemID); }
  };

  const onKeyPressed = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const forId = "search_" + props.itemID;

  return (
    <>
    <label htmlFor={forId} className="searchLabel">{props.labelText}<span aria-hidden>:</span></label>
    <input id={forId} className="CAL-searchBox js-nav-system__link searchTextBox" type="text" value={props.searchText} tabIndex={props.tabIndex} onChange={props.onChange} onFocus={onFocussed} onKeyPress={onKeyPressed} />
    </>
  );
};
